export default class GameHistoryContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "GameHistory";
  }

  show(path, model) {
    const app = this.app;
    const pageId = this.pageId;
    const userdata = app.userdata;
    const gamification = app.gamification;

    const params = path.split("/");
    let userId = params[1];

    //show loading
    const loadingModel = {
      UserDetails: {
        "Name": "Loading...",
        "Avatar": ""
      }
    };


    app.populate(pageId, loadingModel);
    app.swapPage(pageId);

    //load data from server
    if (!userId) userId = userdata.id;

    gamification.GetGameHistory(userId).then(data => {
      let model = data;
      app.populate(pageId, model);
    })

  }

}